var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Branch } from './Model';
export default class default_1 {
    constructor() {
        this.branches = [];
        this.loaded = false;
        this.set = (branches) => {
            this.branches = branches.map(branch => new Branch(branch));
            this.loaded = true;
        };
        this.push = (branch) => {
            this.branches.push(new Branch(branch));
        };
        this.replace = (branch) => {
            this.branches.splice(this.branches.findIndex(f => f.id === branch.id), 1, branch);
        };
        this.pull = (branch) => {
            this.branches.splice(this.branches.findIndex(a => a.id === branch.id), 1);
        };
    }
    read(id) {
        if (id)
            return api.get('branch/' + id).then(branch => new Branch(branch));
        return api.get('branch').then(branches => {
            this.set(branches);
            return branches;
        });
    }
    create(branch) {
        return api.post('branch', branch).then(this.push);
    }
    update(id, branch) {
        return api.put('branch/' + id, branch).then(this.replace);
    }
    disable(id, disabled) {
        return api.patch('branch/' + id, { disabled }).then(this.pull);
    }
}
__decorate([
    observable
], default_1.prototype, "branches", void 0);
__decorate([
    observable
], default_1.prototype, "loaded", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);
__decorate([
    action
], default_1.prototype, "push", void 0);
__decorate([
    action
], default_1.prototype, "replace", void 0);
__decorate([
    action
], default_1.prototype, "pull", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Branches/Store.ts
// module id = 336
// module chunks = 0